import type { LucideIcon } from "lucide-react";
import { Archive, Cloud, FileText } from "lucide-react";

export type SupportServiceId =
  | "document_shredding"
  | "record_management"
  | "digital_solutions";

export type SupportService = {
  id: SupportServiceId;
  icon: LucideIcon;
  iconBgClass: string;
  iconColorClass: string;
  titleKey: string;
  titleDefault: string;
  descriptionKey: string;
  descriptionDefault: string;
  detailTitleKey: string;
  detailTitleDefault: string;
  email: string;
};

export const SUPPORT_SERVICES: SupportService[] = [
  {
    id: "document_shredding",
    icon: FileText,
    iconBgClass: "bg-warning",
    iconColorClass: "text-warning-foreground",
    titleKey: "hub.support.document_shredding.title",
    titleDefault: "Secure Shredding",
    descriptionKey: "hub.support.document_shredding.description",
    descriptionDefault:
      "Support for bin pickup, secure shredding, and shredding schedules",
    detailTitleKey: "hub.support.document_shredding.detail_title",
    detailTitleDefault: "Secure Shredding Support",
    email: "NASelfService.Support@ironmountain.com",
  },
  {
    id: "record_management",
    icon: Archive,
    iconBgClass: "bg-success",
    iconColorClass: "text-success-foreground",
    titleKey: "hub.support.record_management.title",
    titleDefault: "Records Management",
    descriptionKey: "hub.support.record_management.description",
    descriptionDefault: "Support for physical asset storage and ordering.",
    detailTitleKey: "hub.support.record_management.detail_title",
    detailTitleDefault: "Records Management Support",
    email: "NASelfService.Support@ironmountain.com",
  },
  {
    id: "digital_solutions",
    icon: Cloud,
    iconBgClass: "bg-info",
    iconColorClass: "text-info-foreground",
    titleKey: "hub.support.digital_solutions.title",
    titleDefault: "Digital Solutions",
    descriptionKey: "hub.support.digital_solutions.description",
    descriptionDefault: "Support for cloud storage and digital workflows ",
    detailTitleKey: "hub.support.digital_solutions.detail_title",
    detailTitleDefault: "Digital Solutions Support",
    email: "insight.support@ironmountain.com",
  },
];
